import {
    FETCH_CAPABILITIES_SUCCESS,
    FETCH_CAPABILITIES_ERROR,
    FETCH_CAPABILITY_SUCCESS,
    FETCH_CAPABILITY_ERROR,
    CREATE_CAPABILITY_SUCCESS,
    CREATE_CAPABILITY_ERROR,
    UPDATE_CAPABILITY_SUCCESS,
    UPDATE_CAPABILITY_ERROR,
    DELETE_CAPABILITY_SUCCESS,
    DELETE_CAPABILITY_ERROR,
  } from "./types";
  
  const initialState = {
    capabilities: [],
    capability: null,
    error: "",
  };
  
  export default function capabilitiesReducer(state = initialState, action) {
    switch (action.type) {
      case FETCH_CAPABILITIES_SUCCESS:
        return {
          ...state,
          capabilities: action.payload,
          error: "",
        };
      case FETCH_CAPABILITIES_ERROR:
        return {
          ...state,
          error: action.payload,
        };
      case FETCH_CAPABILITY_SUCCESS:
        return {
          ...state,
          capability: action.payload,
          error: "",
        };
      case FETCH_CAPABILITY_ERROR:
        return {
          ...state,
          error: action.payload,
        };
      case CREATE_CAPABILITY_SUCCESS:
        return {
          ...state,
          capabilities: [...state.capabilities, action.payload],
          error: "",
        };
      case CREATE_CAPABILITY_ERROR:
        return {
          ...state,
          error: action.payload,
        };
      case UPDATE_CAPABILITY_SUCCESS:
        return {
          ...state,
          capabilities: state.capabilities.map((capability) =>
            capability._id === action.payload._id ? action.payload : capability
          ),
          error: "",
        };
      case UPDATE_CAPABILITY_ERROR:
        return {
          ...state,
          error: action.payload,
        };
      case DELETE_CAPABILITY_SUCCESS:
        return {
          ...state,
          capabilities: state.capabilities.filter(
            (capability) => capability._id !== action.payload
          ),
          error: "",
        };
      case DELETE_CAPABILITY_ERROR:
        return {
          ...state,
          error: action.payload,
        };
      default:
        return state;
    }
  }
  